import React from 'react'
import {Link} from 'react-router-dom'

import {ArrRightIcon, ColoredBPointsIcon, LogoutIcon, TrolleyIcon, UserIcon} from 'components/CustomIcons'

const tmpBuildiroPoints = 4242

const SideWelcomeBack = ({t, history, user}) => (
  <div className='formDesigned-block sideWelcomeBack'>
    <h6>{t('Welcome back,')} {user.name}</h6>

    <div className='sideWelcomeBack-Bpoints'>
      <div>
        <div>
          <ColoredBPointsIcon/>
          <h6>{t('BUILDIRO POINTS')}</h6>
        </div>
        <div>
          <h5>{tmpBuildiroPoints.toLocaleString('en-GB')}</h5>
        </div>
      </div>

      <div>
        <button onClick={_ => alert('WiP')}>
          <b>{t('Invite & earn extra points')} <ArrRightIcon/></b>
          <span>{t('Invite your friends and earn 100 buildiro points.')}</span>
        </button>
      </div>
    </div>

    <div className='sideWelcomeBack-items'>
      <Link to='/profile' className={history.location.pathname === '/profile' ? 'sideWelcomeBack-itemActive' : ''}>
        <div><TrolleyIcon/></div>
        <div>
          <h6>{t('YOUR ORDERS')}</h6>
          <p>{t('Track your order, Order history')}</p>
        </div>
      </Link>

      <Link to='/profile/settings' className={history.location.pathname === '/profile/settings' ? 'sideWelcomeBack-itemActive' : ''}>
        <div><UserIcon/></div>
        <div>
          <h6>{t('ACCOUNT SETTINGS')}</h6>
          <p>{t('Personal information, Addresses, Billing information')}</p>
        </div>
      </Link>
    </div>

    <Link to='/logout' className='sideWelcomeBack-logout'><LogoutIcon/> {t('LOG OUT')}</Link>
  </div>
)

export default SideWelcomeBack
